import VFormError from './VFormError.js'

export default {
    components: {
        VFormError,
    },
    props: {
        id: {
            type: String,
            default: undefined,
        },
        type: {
            type: String,
            default: 'text',
        },
        label: {
            type: String,
            default: undefined,
        },
        placeholder: {
            type: String,
            default: undefined,
        },
        autocomplete: {
            type: String,
            default: undefined,
        },
        required: {
            type: Boolean,
            default: false,
        },
        field: {
            type: Object,
            required: true,
        },
        lightest: {
            type: Boolean,
            default: false,
        },
    },
    // setup(props) {},
    template: `
        <div class="o-form_field">
            <div
                class="m-input-text"
                :class="{
                    'has-error' : field.$errors.length > 0,
                    'is-valid'  : !field.$invalid,
                    '-lightest': lightest,
                }"
            >
                <label
                    v-if="label"
                    :for="id"
                    class="m-input-text_label | a-text-label"
                >
                    {{ label }}{{ required ? '*' : '' }}
                </label>
                <textarea
                    v-if="type === 'textarea'"
                    :id="id"
                    :placeholder="placeholder"
                    :required="required"
                    class="a-text-large"
                    v-model="field.$model"
                >
                </textarea>
                <input
                    v-else
                    :type="type"
                    :id="id"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"
                    :aria-invalid="required && !field.$model"
                    :required="required"
                    class="a-text-large"
                    v-model="field.$model"
                />
            </div>

            <v-form-error
                :field="field"
            ></v-form-error>
        </div>
    `
}
